var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCopy = function SvgIcCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D85FF",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.666 5.599V2.89h9.291v9.343H4.693zm0 0H2.039v9.263h9.29v-2.628"
  })));
};
export default SvgIcCopy;